<template>
    <section id="main" class="micro">
        <carusel :sliders="ftthSlider" />
        <caracteristic :offset="position"
                       :data="microCharacteristic" />
        <keep-alive>
            <newsletter-button />
        </keep-alive>
        <section class="descriptions presentation" id="presentation">
            <b-container>
                <b-row>
                    <b-col class="img_box" cols="12" sm="12" md="12" lg="6">
                        <b-img fluid :src="require(`@/assets/images/products/ftth/elements/ftth_index05.png`)"
                               alt="FTTH-ONE"></b-img>
                    </b-col>
                    <b-col cols="12" sm="12" md="12" lg="6">
                        <p class="descriptionMulti">{{$t('ftth.presentations.descriptionFirst')}}</p>
                        <p class="descriptionMulti">{{$t('ftth.presentations.descriptionSecond')}}</p>
                        <ul class="descriptionMulti">
                          <li>{{$t('ftth.presentations.listFirst')}}</li>
                          <li>{{$t('ftth.presentations.listSecond')}}</li>
                          <li>{{$t('ftth.presentations.listThird')}}</li>
                          <li>{{$t('ftth.presentations.listForth')}}</li>
                          <li>{{$t('ftth.presentations.listFifth')}}</li>
                          <li>{{$t('ftth.presentations.listSixth')}}</li>
                          <li>{{$t('ftth.presentations.listSeventh')}}</li>
                          <li>{{$t('ftth.presentations.listEighth')}}</li>
                        </ul>
                    </b-col>
                    <carac-desc :data="microProductsCharacteristic" />
                </b-row>
            </b-container>
        </section>
        <section class="parameters">
            <b-container>
                <b-row>
                    <b-col cols='12'>
                        <h3>{{$t('micro.table.title')}}</h3>
                    </b-col>
                    <b-col cols="12">
                        <b-table-simple hover small table-variant="light" responsive="sm">
                          <colgroup>
                            <col>
                            <col>
                          </colgroup>
                          <colgroup>
                            <col>
                            <col>
                            <col>
                          </colgroup>
                          <colgroup>
                            <col>
                            <col>
                          </colgroup>
                          <b-tbody>
                            <b-tr>
                              <b-th colspan="3" class="text-left">{{$t('ftth.table.power.title')}}</b-th>
                            </b-tr>
                            <b-tr class="border">
                              <b-td>{{$t('ftth.table.power.firstLineFirst')}}</b-td>
                              <b-td>V</b-td>
                              <b-td>24</b-td>
                            </b-tr>
                            <b-tr class="border">
                              <b-td>{{$t('ftth.table.power.secondLineFirst')}}</b-td>
                              <b-td>W</b-td>
                              <b-td>100</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th colspan="3" class="text-left">{{$t('ftth.table.fiber.title')}}
                              </b-th>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.fiber.firstLineFirst')}}</b-td>
                              <b-td>N</b-td>
                              <b-td>4 – 70</b-td>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.fiber.secondLineFirst')}}</b-td>
                              <b-td>m/min</b-td>
                              <b-td>25 – 150</b-td>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.fiber.thirdLineFirst')}}</b-td>
                              <b-td>mm</b-td>
                              <b-td>0.5 – 5</b-td>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.fiber.fourthLineFirst')}}</b-td>
                              <b-td>mm</b-td>
                              <b-td>5 – 12</b-td>
                            </b-tr>
                            <b-tr>
                              <b-th colspan="3" class="text-left">{{$t('ftth.table.other.title')}}</b-th>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.other.firstLineFirst')}}</b-td>
                              <b-td>cm</b-td>
                              <b-td>158 x 328 x 268</b-td>
                            </b-tr>
                            <b-tr>
                              <b-td>{{$t('ftth.table.other.secondLineFirst')}}</b-td>
                              <b-td>kg</b-td>
                              <b-td>8</b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-container>

        </section>
        <keep-alive>
            <other-products :otherProducts="otherProducts"/>
        </keep-alive>
        <keep-alive>
            <contact/>
        </keep-alive>
    </section>
</template>

<script>
    export default {
        name: "MicroTyphoon",
        data(){
          return{
              position: true,
              otherProducts: 'heading.otherProducts',
              ftthSlider: [
                  {
                     img: 'ftth/slider/ftth_index02.jpg',
                     title: 'ftth.slider.firstSlide'
                  },
                  {
                      img: 'ftth/slider/ftth_index05.jpg',
                      title: 'ftth.slider.firstSlide'
                  },
                  {
                      img: 'ftth/slider/ftth_index03.jpg',
                      title: 'ftth.slider.secondSlide'
                  },
                  {
                      img: 'ftth/slider/ftth_index01.jpg',
                      title: 'ftth.slider.secondSlide'
                  }
              ],
              microCharacteristic: [
                  { img: 'swiatlowody.svg', title: 'characteristic.fiber-optic', description: '0.5—5 mm'},
                  { img: 'mikrorurki.svg', title: 'characteristic.microducts', description: '5—12 mm'},
              ],
              microProductsCharacteristic:[
                  { img: 'thunderbolt.png', title: '24V/100W'},
                  { img: 'weight.png', title: '8.0'},
                  { img: 'size.png', title: '158× 328× 268'}
              ],
          }
        }
    }
</script>

